import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const riskSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.risk;
  }
);
